import { useCallback, useState } from 'react';
import { assistantListOnlineStatus } from 'services/api/assistant';

/** 查询客服在线状态列表 */
export default function useAssistantList() {
  const [assistantList, setAssistantList] = useState<Assistant.AssistantOnlineStatusInfo[]>([]);
  const fetchAssistantList = useCallback(() => {
    return assistantListOnlineStatus()
      .then((res) => {
        setAssistantList(res);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }, [setAssistantList]);

  return {
    assistantList,
    fetchAssistantList,
  };
}
